import { createContext, PropsWithChildren, useContext, useMemo, useState } from 'react';

type KeyboardShortcutsContextType = {
  enabled: boolean;
  toggleKeyboardShortcuts: (value: boolean) => void;
};

const initialState = {
  enabled: true,
  toggleKeyboardShortcuts: () => {},
};

const KeyboardShortcutsContext = createContext<KeyboardShortcutsContextType>(initialState);

const KeyboardShortcutsProvider = ({ children }: PropsWithChildren) => {
  const [enabled, setEnabled] = useState(initialState.enabled);

  const value = useMemo(
    () => ({
      enabled,
      toggleKeyboardShortcuts: () => setEnabled(!enabled),
    }),
    [enabled]
  );

  return (
    <KeyboardShortcutsContext.Provider value={value}>{children}</KeyboardShortcutsContext.Provider>
  );
};

export const useKeyboardShortcuts = () => useContext(KeyboardShortcutsContext);

export default KeyboardShortcutsProvider;
